import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// ?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_coins_in_exchange_for_discount~1
			funnel: {
				id: 'ob-coins-in-exchange-for-discount',
				locale: ['en'],
			},

			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_coins_in_exchange_for_discount~1
			paywall: {
				experiment: () => import('@/modules/Paywall/instances/experiments/web_coins_in_exchange_for_discount'),
			},
		},
	},
]

export default config
